export default {"src":"/_next/static/media/dots.16d53fc1.svg","height":229,"width":275,"blurWidth":0,"blurHeight":0};